export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Core/Components/ApplicationPathAdminConsoleComponent.vue'),
    contentData: {
        key: 'ApplicationPath',
        visible: true
    }
};